module.exports = __webpack_public_path__ + "Roboto-Light.ea36cd9a0e9eee97012a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/css/themes/fonts/roboto/Roboto-Light.woff
// module id = ../../../../../src/assets/css/themes/fonts/roboto/Roboto-Light.woff
// module chunks = 0